

























import vSelect from "vue-select";

export default {
  name: "BaseSelect",
  components: { vSelect },
  props: {
    value: {
      type: Object,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    selectedOption(option) {
      if (this.value) {
        return option.name === this.value.name;
      }
      return false;
    },
    change(e) {
      const option = this.options.find((o) => {
        return e.id === o.id;
      });
      if (option) {
        this.$emit("input", option);
      }
    },
  },
};
